import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'rr0554',
    ecrans: ['00-2'],
    params: ['id', '?ececleint', '?demcleint', '?rcecleint']
});
